import { RemoteGetAllActivitiesByTask } from 'data/usecases';
import { GetAllActivitiesByTask } from 'domain/usecases';
import { makeApiUrlActivitiesByTask } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetAllActivitiesByTask = (): GetAllActivitiesByTask =>
  new RemoteGetAllActivitiesByTask(
    makeApiUrlActivitiesByTask(),
    makeAxiosHttpClient(),
  );
